export default "__VITE_ASSET__BFJBzrRq__"